import createVueApp from '@/common/createApp'

Styxie.Initializers.UsersSessions = {
  new: async(props) => {
    const { default: SessionsNew } = await import('@/vue_widgets/users/sessions/new/index.vue')
    createVueApp(SessionsNew, { props, layout: null })
  }
}
